if (!customElements.get('collection-main')) {
  customElements.define('collection-main', class CollectionDonor extends BaseElement {
    constructor () {
      super();

      this.initEvents();
    }

    connectedCallback () {
      this.initFilters();
    }

    initEvents () {
      this.initTreatmentCountryEvent();
    }

    initFilters() {
      this.initTreatmentNoMatchGuard();
      this.initViewSwitcher();
      this.initFiveBigTraits();
      this.initHeightRangeBoxes();
      this.initWeightRangeBoxes();
      this.initIqRangeBoxes();
      this.initSorting();
      this.initHomepageFindDonorParams();
      this.initBannerClose();
      this.initUrls();
      this.initMobile();

      const submitBtn = this.querySelector('.mobile-facets__footer button:not(.js-initialized)');

      if (submitBtn) {
        submitBtn.classList.add('js-initialized');
        submitBtn.addEventListener('click', e => {
          e.preventDefault();

          const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          form.onSubmitHandler();

          submitBtn.closest('.mobile-facets__wrapper').querySelector('summary').click();
        });
      }
    }

    initBannerClose() {
      const closeButtons = document.querySelectorAll('.circle-container.close');

      for (const item of closeButtons) {
        const banner = item.closest('.grid__item--banner');
  
        item.addEventListener('click', function() {
          banner.style.display = 'none';
        });
      }
    }

    initHomepageFindDonorParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('source');

      if (source === 'homepage') {
        const minHeight = urlParams.get('filter.p.m.donor.height_range_min');

        if (minHeight) {
          const maxHeight = urlParams.get('filter.p.m.donor.height_range_max');
          const minInput = document.querySelector('.filter-p-m-donor-height-range .range-input--min');
          const maxInput = document.querySelector('.filter-p-m-donor-height-range .range-input--max');

          minInput.value = minHeight;
          maxInput.value = maxHeight;

          const event = new Event('change', { bubbles: true });
          minInput.dispatchEvent(event);
          maxInput.dispatchEvent(event);
        }

        const minIQ = urlParams.get('filter.p.m.donor.iq_score_range_min');

        if (minIQ) {
          const maxIQ = urlParams.get('filter.p.m.donor.iq_score_range_max');
          const minIQInput = document.querySelector('.filter-p-m-donor-iq_score-range .range-input--min');
          const maxIQInput = document.querySelector('.filter-p-m-donor-iq_score-range .range-input--max');

          minIQInput.value = minIQ;

          if (maxIQInput) {
            maxIQInput.value = maxIQ;
          }

          const event = new Event('change', { bubbles: true });
          minIQInput.dispatchEvent(event);

          if (maxIQInput) {
            maxIQInput.dispatchEvent(event);
          }
        }

      }

    }

     initSorting() {
       const sortingRadios = document.querySelectorAll('#facetFiltersSorting input[type="radio"]');
       const sortingSelect = document.querySelector('#SortBy');
       const sortDrawer = document.querySelector('.sort-drawer-trigger');
       const activeSortVal = sortDrawer.querySelector('.active-sort-val');
       const closeWrap = sortDrawer.querySelector('.close-wrap');
       const overlayWrap = sortDrawer.querySelector('#facetFiltersSorting');
       const sortingDrawer = sortDrawer.querySelector('.sorting-drawer');

       const urlParams = new URLSearchParams(window.location.search);
       const initialSortValue = urlParams.get('sort_by');

       let initialSortDisplayName = '';
       switch (initialSortValue) {
         case 'manual':
           initialSortDisplayName = window.collectionStrings.sortManual;
           break;
         case 'created-ascending':
           initialSortDisplayName = window.collectionStrings.sortCreatedAscending;
           break;
         case 'created-descending':
           initialSortDisplayName = window.collectionStrings.sortCreatedDescending;
           break;
         default:
           initialSortDisplayName = initialSortValue;
       }

       activeSortVal.textContent = initialSortDisplayName;

       sortingRadios.forEach(radio => {
         radio.addEventListener('change', handleSortingOptionChange);
       });

       sortingSelect.addEventListener('change', handleSortingOptionChange);

       closeWrap.addEventListener('click', toggleSortDrawer);
       // overlayWrap.addEventListener('click', toggleSortDrawer);
       // sortingDrawer.addEventListener('click', handleSortingDrawerClick);

       function toggleSortDrawer(event) {
         if (sortDrawer.hasAttribute('open')) {
           sortDrawer.removeAttribute('open');
         }
       }

     /*  function handleSortingDrawerClick(event) {
         const closeWrap = sortDrawer.querySelector('.close-wrap');
         if (event.target === closeWrap) {
           event.stopPropagation();
           if (sortDrawer.hasAttribute('open')) {
             sortDrawer.removeAttribute('open');
           }
         }
       }*/

       function handleSortingOptionChange(event) {
         const selectedValue = event.target.value;
         console.log('Sort changed to: ' + selectedValue);
         
         if (selectedValue === '__variantprice-asc') {
           window.location = '/collections/find-donors-lowest-price' + window.location.search.replace(/(\?|&)sort_by=[^&]*/,'');
         } else if (selectedValue === '__variantprice-desc') {
           window.location = '/collections/find-donors-highest-price' + window.location.search.replace(/(\?|&)sort_by=[^&]*/,'');
         } else {
           const searchParams = new URLSearchParams(window.location.search);
           searchParams.set('sort_by', selectedValue);
           window.location.href = window.location.pathname + '?' + decodeURI(searchParams.toString());
         }
       }
     }

    initFiveBigTraits () {
      const rangeSliders = document.querySelectorAll('.range-slider:not(.js-initialized)');

      rangeSliders.forEach(rangeSlider => {
        rangeSlider.classList.add('js-initialized');
        rangeSlider.dataset.firstClickIndex = '0';

        const paramName = rangeSlider.dataset.filterParamName;

        const getLowestValue = ()=> {
          let lowestValue = null;
          document.querySelectorAll(`.mobile-facets__checkbox[name="${paramName}"]:checked`).forEach(
            checkbox => lowestValue = lowestValue === null ? parseInt(checkbox.value) : Math.min(lowestValue, parseInt(checkbox.value))
          );
          return lowestValue;
        };

        const getHighestValue = () => {
          let highestValue = null;
          document.querySelectorAll(`.mobile-facets__checkbox[name="${paramName}"]:checked`).forEach(
            checkbox => highestValue = highestValue === null ? parseInt(checkbox.value) : Math.max(highestValue, parseInt(checkbox.value))
          );
          return highestValue;
        };

        const urlParams = new URLSearchParams(window.location.search);
        let min = getLowestValue();
        let max = getHighestValue();
        let clickTimeout;

        if (urlParams.get(`${paramName}_min`)
          && !Number.isNaN(parseInt(urlParams.get(`${paramName}_min`)))
        ) {
          min = parseInt(urlParams.get(`${paramName}_min`));
          rangeSlider.querySelector(`[name="${paramName}_min"]`).value = min;
          rangeSlider.querySelector(`[name="${paramName}_min"]`).checked = true;
        }

        if (urlParams.get(`${paramName}_max`)
          && !Number.isNaN(parseInt(urlParams.get(`${paramName}_max`)))
        ) {
          max = parseInt(urlParams.get(`${paramName}_max`));
          rangeSlider.querySelector(`[name="${paramName}_max"]`).value = max;
          rangeSlider.querySelector(`[name="${paramName}_max"]`).checked = true;
        }

        // Reset clicks after filter submit/close
        setInterval(() => {
          if (!document.querySelector('.mobile-facets__disclosure').classList.contains('menu-opening')) {
            rangeSlider.dataset.firstClickIndex = '0';
          }
        }, 333);

        const rerenderBars = () => {
          rangeSlider.querySelectorAll('.range-slider__part').forEach(bar => {
            if (parseInt(bar.dataset.rangePart) >= min && parseInt(bar.dataset.rangePart) <= max) {
              bar.classList.add('active');
            } else {
              bar.classList.remove('active');
            }
          });
        }

        const rerenderLabels = () => {
          document.querySelectorAll(`[data-big-trait-label="${paramName}"]`).forEach(label => {
            label.innerHTML = '';
            label.innerHTML += window.bigFiveStrings[`value_${min}`];

            if (max !== min) {
              label.innerHTML += ' - ' + window.bigFiveStrings[`value_${max}`];
            }
          });
        }

        const updateRanges = () => {
          if (min !== null && max !== null) {
            rangeSlider.querySelector(`[name="${paramName}_min"]`).value = min;
            rangeSlider.querySelector(`[name="${paramName}_min"]`).checked = true;
            rangeSlider.querySelector(`[name="${paramName}_max"]`).value = max;
            rangeSlider.querySelector(`[name="${paramName}_max"]`).checked = true;
          } else {
            rangeSlider.querySelector(`[name="${paramName}_min"]`).checked = false;
            rangeSlider.querySelector(`[name="${paramName}_max"]`).checked = false;
          }
        }

        const highlightBars = (current) => {
          const newMin = Math.min(min, current);
          const newMax = Math.max(max, current);

          rangeSlider.querySelectorAll('.range-slider__part').forEach(bar => {
            if (parseInt(bar.dataset.rangePart) !== parseInt(rangeSlider.dataset.firstClickIndex)
              && parseInt(bar.dataset.rangePart) >= newMin
              && parseInt(bar.dataset.rangePart) <= newMax
            ) {
              bar.classList.add('highlight');
            }
          });
        }

        const unhighlightBars = () => {
          rangeSlider.querySelectorAll('.range-slider__part').forEach(bar => bar.classList.remove('highlight'));
        }

        const clickedValue = (value) => {
          if (parseInt(rangeSlider.dataset.firstClickIndex) === 0) {
            min = value;
            max = value;
          } else {
            min = Math.min(min, value);
            max = Math.max(max, value);
          }

          rangeSlider.dataset.firstClickIndex = parseInt(rangeSlider.dataset.firstClickIndex) === 0
            ? value
            : '0';

          clearTimeout(clickTimeout);

          if (parseInt(rangeSlider.dataset.firstClickIndex) !== 0) {
            // Set to first click if not clicked second time withing 3s
            clickTimeout = setTimeout(() => {
              rangeSlider.dataset.firstClickIndex = '0';
              unhighlightBars();
            }, 3000);
          }

          document.querySelectorAll(`.mobile-facets__checkbox[name="${paramName}"]`).forEach(checkbox => {
            const inRange = parseInt(checkbox.value) >= min && parseInt(checkbox.value) <= max;

            if (checkbox.checked && !inRange) {
              checkbox.checked = false;
            } else if (!checkbox.checked && inRange) {
              checkbox.checked = true;
            }
          });

          rerenderBars();
          updateRanges();
        }

        rangeSlider.querySelectorAll('.range-slider__part').forEach(bar => {
          bar.addEventListener('click', e => {
            e.preventDefault();

            const value = parseInt(bar.dataset.rangePart);

            clickedValue(value);
          });

          bar.addEventListener('mouseenter', e => {
            if (parseInt(rangeSlider.dataset.firstClickIndex) !== 0) {
              highlightBars(parseInt(bar.dataset.rangePart));
            }
          });

          bar.addEventListener('mouseleave', e => {
            unhighlightBars();
          });
        });

        rerenderBars();
        rerenderLabels();
      });

      document.addEventListener('click', e => {
        if (!e.isTrusted) {
          // Triggered by code
          return;
        }

        const rangeSlider = e.target.closest('.range-slider');
        rangeSliders.forEach(rs => {
          if (rangeSlider !== rs) {
            rs.dataset.firstClickIndex = '0'
          }
        });
      });
    }

    initViewSwitcher () {
      const viewSwitchInputs = document.querySelectorAll('.view-switch input[type="radio"]:not(.js-initialized)');

      function handleViewSwitchChange(e) {
        const collectionGrid = document.querySelector('.main-collection-grid');
        const iconContainers = document.querySelectorAll('.switch-option-wrap');

        iconContainers.forEach(container => {
          container.classList.remove('selected');
        });

        const selectedIconContainer = e.target.parentNode;
        selectedIconContainer.classList.add('selected');

        if (document.querySelector('#list-view').checked) {
          collectionGrid.classList.add('list-view');
          sessionStorage.setItem('listView', 'true');
        } else {
          collectionGrid.classList.remove('list-view');
          sessionStorage.setItem('listView', 'false');
        }
      }

      function restoreViewState() {
        let listViewState = sessionStorage.getItem('listView') || 'true';
        const collectionGrid = document.querySelector('.main-collection-grid');
        const listIconContainer = document.querySelector('.switch-option-wrap.js-list-view');
        const gridIconContainer = document.querySelector('.switch-option-wrap.js-grid-view');

        if (listViewState === 'true') {
          if (collectionGrid && listIconContainer) {
            collectionGrid.classList.add('list-view');
            listIconContainer.classList.add('selected');
            gridIconContainer.classList.remove('selected');
          }
        } else {
          if (collectionGrid && listIconContainer) {
            collectionGrid.classList.remove('list-view');
            listIconContainer.classList.remove('selected');
            gridIconContainer.classList.add('selected');
          }
        }
      }

      viewSwitchInputs.forEach(input => {
        input.classList.add('js-initialized');
        input.addEventListener('change', handleViewSwitchChange);
      });

      restoreViewState();
    }

    initRangeBoxesFilters (rangeSelector, name) {
      const rangeMinInput = rangeSelector.querySelector('.range-input--min');
      const rangeMaxInput = rangeSelector.querySelector('.range-input--max');
      const rangeFilter = document.querySelector('[data-range-filter="' + name + '"]');
      const params = new URLSearchParams(window.location.search);
      const hasMinValue = params.has(rangeMinInput.name) && !Number.isNaN(parseInt(params.get(rangeMinInput.name)));
      const hasMaxValue = params.has(rangeMaxInput.name) && !Number.isNaN(parseInt(params.get(rangeMaxInput.name)));

      if (params.has(rangeMinInput.name)) {
        rangeMinInput.value = params.get(rangeMinInput.name);

        if (rangeFilter && rangeFilter.querySelector('[data-range-min]')) {
          rangeFilter.querySelector('[data-range-min]').textContent = hasMaxValue
            ? params.get(rangeMinInput.name)
            : params.get(rangeMinInput.name) + '+';
        }
      }

      if (rangeFilter) {
        rangeFilter.querySelector('[data-range-separator]').style.display = hasMinValue && hasMaxValue ? '' : 'none';
      }

      if (params.has(rangeMinInput.name)) {
        rangeMaxInput.value = params.get(rangeMaxInput.name);

        if (rangeFilter && rangeFilter.querySelector('[data-range-max]')) {
          rangeFilter.querySelector('[data-range-max]').textContent = hasMinValue
            ? params.get(rangeMaxInput.name)
            : '<' + params.get(rangeMaxInput.name);
        }
      }

      if (rangeFilter) {
        rangeFilter.addEventListener('click', e => {
          e.preventDefault();

          const currentParams = new URLSearchParams(window.location.search);

          currentParams.forEach((paramValue, paramName) => {
            if (paramName === name) {
              currentParams.delete(paramName);
            }
          });

          currentParams.delete(rangeMinInput.name);
          currentParams.delete(rangeMaxInput.name);

          rangeFilter.href = `${window.location.pathname}?${currentParams}`;

          const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
          form.onActiveFilterClick(e);
        });
      }
    }

    initRangeBoxes (rangeSelector) {
      const rangeMinInput = rangeSelector.querySelector('.range-input--min');
      const rangeMaxInput = rangeSelector.querySelector('.range-input--max');

      let lastMinValue = parseInt(rangeMinInput.value);
      let lastMaxValue = parseInt(rangeMaxInput.value);

      let delayTimer;

      const updateCheckboxes = () => {
        clearTimeout(delayTimer);

        delayTimer = setTimeout(() => {
          const urlParams = new URLSearchParams(window.location.search);
          const source = urlParams.get('source');
          const minValue = parseInt(rangeMinInput.value);
          const maxValue = parseInt(rangeMaxInput.value);

          if (minValue !== lastMinValue || maxValue !== lastMaxValue || source === 'homepage') {
            lastMinValue = minValue;
            lastMaxValue = maxValue;

            this.updateCheckboxes(rangeMinInput, rangeMaxInput);
          }
        }, 0);
      };

      const events = ['input', 'blur'];

      events.forEach(event => {
        rangeMinInput.addEventListener(event, updateCheckboxes);
        rangeMaxInput.addEventListener(event, updateCheckboxes);
      });
    }

    initHeightRangeBoxes () {
      const heightRangeSelector = document.querySelector('.filter-p-m-donor-height-range');

      if (heightRangeSelector) {
        this.initRangeBoxesFilters(heightRangeSelector, 'filter.p.m.donor.height');

        if (!heightRangeSelector.classList.contains('js-initialized')) {
          heightRangeSelector.classList.add('js-initialized');
          this.initRangeBoxes(heightRangeSelector);
        }
      }
    }

    initWeightRangeBoxes () {
      const weightRangeSelector = document.querySelector('.filter-p-m-donor-weight-range');

      if (weightRangeSelector) {
        this.initRangeBoxesFilters(weightRangeSelector, 'filter.p.m.donor.weight');

        if (!weightRangeSelector.classList.contains('js-initialized')) {
          weightRangeSelector.classList.add('js-initialized');
          this.initRangeBoxes(weightRangeSelector);
        }
      }
    }

    initIqRangeBoxes () {
      const iqRangeSelector = document.querySelector('.filter-p-m-donor-iq_score-range');

      if (iqRangeSelector) {
        this.initRangeBoxesFilters(iqRangeSelector, 'filter.p.m.donor.iq_score');

        if (!iqRangeSelector.classList.contains('js-initialized')) {
          iqRangeSelector.classList.add('js-initialized');
          this.initRangeBoxes(iqRangeSelector);
        }
      }
    }

    updateCheckboxes (rangeMinInput, rangeMaxInput) {
      const minValue = parseInt(rangeMinInput.value);
      const maxValue = parseInt(rangeMaxInput.value);
      const parentElement = rangeMinInput.closest('.mobile-facets__list');
      const checkboxes = parentElement.querySelectorAll('.mobile-facets__checkbox');

      parentElement.querySelectorAll('.not-existing-value').forEach(input => input.remove());

      let foundValues = false;

      checkboxes.forEach(function (checkbox) {
        const checkboxValue = parseInt(checkbox.value);
        const isChecked = checkbox.checked;

        if ((checkboxValue >= minValue && checkboxValue <= maxValue && !isChecked) || (isChecked && (checkboxValue < minValue || checkboxValue > maxValue))) {
          checkbox.click();
        }

        if (checkboxValue >= minValue && checkboxValue <= maxValue) {
          foundValues = true;
        }

        if (!Number.isNaN(minValue) && !Number.isNaN(maxValue)) {
          checkbox.checked = (checkboxValue >= minValue && checkboxValue <= maxValue);
        } else if (Number.isNaN(minValue) && Number.isNaN(maxValue)) {
          checkbox.checked = false;
        } else if (!Number.isNaN(minValue)) {
          checkbox.checked = (checkboxValue >= minValue);
        } else if (!Number.isNaN(maxValue)) {
          checkbox.checked = (checkboxValue <= maxValue);
        } else {
          console.error('Failed to determine checkbox value!', checkbox);
          checkbox.checked = false;
        }
      });

      if (!foundValues) {
        const input = document.createElement('input');
        input.classList.add('not-existing-value');
        input.name = rangeMinInput.name.replace('_range_min', '');
        input.type = 'hidden';
        input.value = rangeMinInput.value;
        parentElement.appendChild(input);

        // const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        // form.onSubmitHandler();
      }
    }

    // When the selected treatment tag matches no products, Shopify 301-redirects
    // the collection path (/collections/find-donors/treatment-al) to the bare
    // collection URL, stripping the tag — it does NOT keep the tag and show an
    // empty result. So by the time a no-match page renders there is no
    // treatment-* tag left in the URL to inspect; the URL is useless here.
    //
    // Instead we detect the no-match from the user's *selection* — the same
    // country/state the redirect builds its tag from — and compare it against
    // the treatment-* tags that actually exist on products in this collection,
    // exposed from collection.all_tags via the data-treatment-tags attribute.
    // If the selected tag isn't among them, no donor carries it (e.g. Albania,
    // or an AU state with no donors such as NSW/VIC), so we render the no-match
    // message over the full catalogue Shopify fell back to.
    //
    // The selection may not be known at connectedCallback, so we also re-check
    // when the treatment country/state is set or changes — the same broadcasts
    // that drive the redirect.
    //
    // Fail open: if the collection's tag list is empty/unavailable we do nothing
    // and leave the grid as-is, so a missing signal can never hide every donor.
    initTreatmentNoMatchGuard () {
      if (window.theme.request.page_type !== 'collection') {
        return;
      }

      const evaluate = () => this.evaluateTreatmentNoMatch();

      this.onBroadcast('treatment_country', evaluate);
      this.onBroadcast('treatment_au_state_change', evaluate);

      evaluate();
    }

    evaluateTreatmentNoMatch () {
      // Single resolver on TreatmentCountry — safe before app.init() has run.
      const selection = window.app && window.app.treatmentCountry
        ? window.app.treatmentCountry.getSelection()
        : { country: null, state: null };

      const country = selection.country;

      // No treatment country chosen — nothing to guard.
      if (!country) {
        return;
      }

      const state = selection.state;

      // Same tag the redirect builds: AU narrows to a state tag once a state is
      // chosen (treatment-au-qld), otherwise the country tag (treatment-au).
      const selectedTag = (country === 'AU' && state)
        ? 'treatment-' + ('' + state).toLowerCase()
        : 'treatment-' + ('' + country).toLowerCase();

      const collectionTreatmentTags = (this.dataset.treatmentTags || '')
        .split('+')
        .filter(tag => tag.length > 0);

      // No signal available — fail open rather than hide every donor.
      if (collectionTreatmentTags.length === 0) {
        return;
      }

      // A donor carries this treatment tag — real matches, nothing to do.
      if (collectionTreatmentTags.indexOf(selectedTag) > -1) {
        return;
      }

      // No donor carries the selected treatment tag: Shopify stripped it and
      // fell back to the full catalogue, so render the no-match message.
      this.renderTreatmentNoMatch();
    }

    renderTreatmentNoMatch () {
      const container = document.getElementById('ProductGridContainer');

      if (container) {
        // Localised copy comes from the Liquid `t:` filter via a data attribute,
        // since we can't call `t:` from JS. Fall back to English if it's absent.
        const message = this.dataset.noMatchText
          || 'There are no donors available for your chosen treatment location. Donors may be available in other locations if you\'re able to travel for treatment.';

        const heading = document.createElement('h2');
        heading.className = 'title title--primary';
        heading.textContent = message;

        container.innerHTML =
          '<div class="collection collection--empty page-width" id="product-grid">'
          + '<div class="title-wrapper center"></div>'
          + '</div>';
        container.querySelector('.title-wrapper').appendChild(heading);
      }

      // Clear the product counts so they don't contradict the no-matches message.
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(count => {
        count.textContent = '';
      });
    }

    initTreatmentCountryEvent () {
      const applyTreatmentTag = () => {
        if (window.theme.request.page_type !== 'collection') {
          return;
        }

        const selection = window.app.treatmentCountry.getSelection();
        const country = selection.country;

        if (!country) {
          return;
        }

        const state = selection.state;

        // Australia narrows to a state-specific tag (e.g. treatment-au-nsw) once a
        // state is selected; otherwise we filter by the country tag (treatment-au).
        const treatmentTag = (country === 'AU' && state)
          ? 'treatment-' + state.toLowerCase()
          : 'treatment-' + country.toLowerCase();

        const path = window.location.pathname.split('/').filter(i => i.length > 0);
        let currentTags = [];

        if (path.length >= 3 && path[0] === 'collections') {
          currentTags = path[2].split('+');
        }

        if (currentTags.indexOf(treatmentTag) > -1) {
          return;
        }

        const newTags = [];

        currentTags.forEach(tag => {
          if (!tag.startsWith('treatment-')) {
            newTags.push(tag);
          }
        });

        newTags.push(treatmentTag);

        let searchParams = '';

        if (window.location.search) {
          searchParams = window.location.search;

          if (searchParams.startsWith('?')) {
            searchParams = searchParams.substring(1);
          }
        }

        const url = path[0].length === 2
          ? '/' + path[0] + '/' + path[1] + '/'  + path[2] + '/' + newTags.join('+')
          : '/' + path[0] + '/' + path[1] + '/' + newTags.join('+');

        const finalUrl = searchParams
          ? url + '?' + searchParams
          : url;

        if (finalUrl !== window.location.pathname && treatmentTag !== window.app.cache.get('treatment_redirected_tag')) {
          window.app.cache.put('treatment_redirected_tag', treatmentTag, 15);

          window.location.href = finalUrl;
        }
      };

      // Re-filter when either the country or the AU state changes.
      this.onBroadcast('treatment_country', () => applyTreatmentTag());
      this.onBroadcast('treatment_au_state_change', () => applyTreatmentTag());

      return;
      const treatmentCountry = document.querySelector('#collection-treatment-country');

      if (!treatmentCountry) {
        return;
      }

      if (!treatmentCountry.classList.contains('js-initialized')) {
        treatmentCountry.addEventListener('change', e => {
          let url = treatmentCountry.dataset.collectionUrl;
          let oldTags = window.location.pathname.replace(url, '');

          if (oldTags.startsWith('/')) {
            oldTags = oldTags.substring(1);
          }

          oldTags = oldTags.split('+');
          const newTags = [];

          if (treatmentCountry.value) {
            newTags.push('treatment-' + treatmentCountry.value);
          }

          oldTags.forEach(tag => {
            if (tag && !tag.startsWith('treatment-')) {
              newTags.push(tag);
            }
          });

          if (newTags.length > 0) {
            if (!url.endsWith('/')) {
              url += '/';
            }

            url += newTags.join('+');
          }

          let searchParams = '';

          if (window.location.search) {
            searchParams = window.location.search;

            if (searchParams.startsWith('?')) {
              searchParams = searchParams.substring(1);
            }
          }

          const finalUrl = searchParams
            ? url + '?' + searchParams
            : url;

          window.location.href = finalUrl;
        });
      }
    }

    saveFilters (query)
    {
      const search = new URLSearchParams(query);
      search.delete('auto');

      app.cache.put(this.dataset.handle + '_filters', search.toString());

      document.querySelectorAll('a').forEach(a => {
        if (a.pathname && a.pathname.startsWith('/collections/' + this.dataset.handle)) {
          a.search = search;
        }
      });
    }

    initUrls ()
    {
      this.querySelectorAll('product-card a').forEach(a => {
        if (a.search) {
          const search = new URLSearchParams(a.search);

          // Remove variant from URL params
          if (search.get('variant')) {
            search.delete('variant');

            a.search = search;
          }
        }
      });
    }

    initMobile ()
    {
      window.addEventListener('resize', () => {
        this.checkMobile();
      });

      window.addEventListener('scroll', () => {
        this.checkMobile();
      });

      this.checkMobile();
    }

    checkMobile ()
    {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const grid = this.querySelector('.product-grid');
      const startY = grid.offsetTop;

      if (scrollTop > startY) {
        document.body.classList.add('scrolled-past-product-grid');
      } else {
        document.body.classList.remove('scrolled-past-product-grid');
      }
    }
  });
}